// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__RrNcV {
  margin: 42px 24px 0 24px;

  @media (min-width: 768px) {
    margin: 40px 24px 0 24px;
    padding: 7px 0 1px 0;
  }
  @media (min-width: 1024px) {
    margin: 40px 0 0 0;
  }
}
.heading__D57Sl {

  margin-bottom: 16px;
  padding: 0;

  font-weight: var(--fontWeightBold);
}
.content__X2YyN {

  margin-top: 6px;
  padding: 5px 0 1px 0;

  @media (min-width: 768px) {
    margin-top: 8px;
    padding: 1px 0 7px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TransactionPanelSection/TransactionPanelSection.module.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;;EAExB;IACE,wBAAwB;IACxB,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;AACF;AAEA;;EAGE,mBAAmB;EACnB,UAAU;;EAEV,kCAAkC;AACpC;AAEA;;EAGE,eAAe;EACf,oBAAoB;;EAEpB;IACE,eAAe;IACf,oBAAoB;EACtB;AACF","sourcesContent":["@import '../../styles/customMediaQueries.css';\n\n.root {\n  margin: 42px 24px 0 24px;\n\n  @media (--viewportMedium) {\n    margin: 40px 24px 0 24px;\n    padding: 7px 0 1px 0;\n  }\n  @media (--viewportLarge) {\n    margin: 40px 0 0 0;\n  }\n}\n\n.heading {\n  composes: p from global;\n\n  margin-bottom: 16px;\n  padding: 0;\n\n  font-weight: var(--fontWeightBold);\n}\n\n.content {\n  composes: marketplaceSmallFontStyles from global;\n\n  margin-top: 6px;\n  padding: 5px 0 1px 0;\n\n  @media (--viewportMedium) {\n    margin-top: 8px;\n    padding: 1px 0 7px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__RrNcV`,
	"heading": `heading__D57Sl p`,
	"content": `content__X2YyN marketplaceSmallFontStyles`
};
export default ___CSS_LOADER_EXPORT___;
